import { atom } from "recoil";
import { Company } from "../entities/company";

export const selectedCompaniesAtom = atom({
  key: "selectedCompaniesAtom",
  default: [] as Company[],
});
